module.exports = __webpack_public_path__ + "img/appstore.7a2966fe.jpg";